/*eslint-disable*/
import React from "react";
import {
  Flex,
  Link,
  List,
  ListItem,
  Text,
  Button,
  useColorMode,
  useColorModeValue,
  Box,
} from "@chakra-ui/react";
import Chat from "../../views/Chat";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  const { toggleColorMode } = useColorMode();
  return (
    <Flex
      zIndex='3'
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent='space-between'
      px={{ base: "30px", md: "50px" }}
      pb='30px'>
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}>
        {" "}
        &copy; {1900 + new Date().getYear()}
        <Text as='span' fontWeight='500' ms='4px'>
          Ucleany . All Rights Reserved. Created by
          <Link
            mx='3px'
            color={textColor}
            href='https://www.hisoftlb.com'
            target='_blank'
            fontWeight='700'>
            Ucleany
          </Link>
        </Text>
      </Text>
      <List display='flex'>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link
            fontWeight='500'
            color={textColor}
            // href='mailto:info@hisoftlb.com'
            >
            Support
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link
            fontWeight='500'
            color={textColor}
            // href='https://www.hisoftlb.com'
            >
            License
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link
            fontWeight='500'
            color={textColor}
            // href='https://hisoftlb.com'
            >
            Terms of Use
          </Link>
        </ListItem>
        <ListItem>
          <Link
            fontWeight='500'
            color={textColor}
            // href='https://hisoftlb.com'
            >
            Blog
          </Link>
        </ListItem>
        <ListItem ms="20px" ml="30px">
{sessionStorage.getItem('role_id') !== '1' && (
  <Box
    position="fixed"
    bottom="24px"
    right="24px"
    zIndex="1500"
  >
    <Chat />
  </Box>
)}

        </ListItem>
      </List>
    </Flex>
  );
}
